//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/javascript/util'
// 只能在微信环境下使用，并且微信签名必须正确，在签名完后ios下需进行一次页面刷新（请使用以下代码,可参考/app/museum/center-museum/index.vue）
// ios下需不需要刷新，还需进一步测试
// if(!sessionStorage.getItem(this.$route.name) && this.$bridge.kind === 1){
//     sessionStorage.setItem(this.$route.name,1);
//     window.location.reload()
// }
export default {
  name: 'Gomini',
  props: {
    username: String,
    path: {
      type: String,
      default: '',
    }
  },
  data () {
    return {}
  },
  methods: {
    handleErrorFn (e) {
      console.log('fail', e.detail);
    },
    handleLaunchFn (e) {
      console.log('success');
    }
  }
}
